import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { guestRoutes, routes } from "../../constants/routes";
import { DashboardContainer } from "../dashboard/DashboardContainer";
import { DataProvider } from "./DataProvider";
import { useAuth } from "../../hooks/useAuth";
import { Loader } from "../elements/Loader";
import { usePermissions } from "../../hooks/auth/usePermissions";

export const MainContainer = () => {
  const { loggedIn } = useAuth();
  const { complete } = usePermissions();

  // not logged in
  if (loggedIn === false)
    return (
      <>
        <Routes>
          {guestRoutes.map(({ path, component }, i) => (
            <Route path={path} element={component} key={i} exact={true} />
          ))}
          <Route path="*" element={<Navigate replace to="/admin" />} />
        </Routes>
      </>
    );

  // logged in
  if (loggedIn === true && complete)
    return (
      <>
        <DataProvider />
        <DashboardContainer>
          <Routes>
            {routes.map(({ path, component }, i) => (
              <Route path={path} element={component} key={i} exact={true} />
            ))}
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </DashboardContainer>
      </>
    );

  // data loading
  return <Loader full />;
};
